import { useTranslation } from 'react-i18next';

import type { ProtocolValidityOption } from '../Protocols.types';

export const useProtocolValidityOptions = (): ProtocolValidityOption[] => {
  'use memo';
  const { t } = useTranslation('common');

  return [
    { value: 'all', name: t('adminPortal.protocols.filterAll') },
    { value: 'current', name: t('adminPortal.protocols.filterCurrent') },
    { value: 'expired', name: t('adminPortal.protocols.filterExpired') }
  ];
};
